import Vue from 'vue'
import VueRouter from 'vue-router'

import {
  canNavigate,
} from '@/libs/acl/routeProtection'

import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils'

// Routes
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',

  base: process.env.BASE_URL,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 80,
        },
      }
    }

    return {
      x: 0,
      y: 0,
    }
  },

  routes: [
    {
      path: '/',
      redirect: {
        name: 'dashboard-ecommerce',
      },
    },

    ...apps,
    ...dashboard,
    ...pages,

    /*
     * حتماً باید آخرین route باشد.
     *
     * استفاده از name مانع ایجاد redirect نسبی و
     * حلقه بی‌نهایت error-404 می‌شود.
     */
    {
      path: '*',
      redirect: {
        name: 'error-404',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  /*
   * کاربر اجازه ورود به route را ندارد.
   */
  if (!canNavigate(to)) {
    if (!isLoggedIn) {
      return next({
        name: 'auth-login',

        /*
         * بعد از ورود بتوانیم کاربر را به
         * صفحه‌ای که قصد بازکردنش را داشت برگردانیم.
         */
        query: {
          redirect: to.fullPath,
        },
      })
    }

    return next({
      name: 'misc-not-authorized',
    })
  }

  /*
   * جلوگیری از ورود کاربر لاگین‌شده
   * به login یا register.
   */
  if (
      to.meta
      && to.meta.redirectIfLoggedIn
      && isLoggedIn
  ) {
    const userData = getUserData()

    const role =
        userData
        && userData.data
        && userData.data.user
            ? userData.data.user.role
            : null

    const homeRoute =
        getHomeRouteForLoggedInUser(role)

    /*
     * اگر homeRoute معتبری وجود نداشت،
     * navigation معمولی ادامه پیدا کند.
     */
    if (!homeRoute) {
      return next()
    }

    /*
     * جلوگیری از redirect شدن مسیر به خودش.
     */
    const isSameRouteByName =
        typeof homeRoute === 'object'
        && homeRoute.name
        && homeRoute.name === to.name

    const isSameRouteByPath =
        (
            typeof homeRoute === 'string'
            && homeRoute === to.path
        )
        || (
            typeof homeRoute === 'object'
            && homeRoute.path
            && homeRoute.path === to.path
        )

    if (
        isSameRouteByName
        || isSameRouteByPath
    ) {
      return next()
    }

    /*
     * وجود return مهم است؛ در کد قبلی next
     * دوباره در انتهای guard اجرا می‌شد.
     */
    return next(homeRoute)
  }

  return next()
})

router.afterEach(() => {
  const appLoading =
      document.getElementById('loading-bg')

  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.onError(error => {
  console.error(
      '[Vue Router] Navigation error:',
      error,
  )
})

export default router